import { render, staticRenderFns } from "./HospitalizationCard.vue?vue&type=template&id=175d1828&scoped=true"
import script from "./HospitalizationCard.vue?vue&type=script&lang=js"
export * from "./HospitalizationCard.vue?vue&type=script&lang=js"
import style0 from "./HospitalizationCard.vue?vue&type=style&index=0&id=175d1828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175d1828",
  null
  
)

export default component.exports